import {
  ROUTE_PRODUCTS,
  ROUTE_PRODUCT_CREATE,
  ROUTE_PRODUCT_CREATE_ACTIVITY,
  ROUTE_PRODUCT_CREATE_APP,
  ROUTE_PRODUCT_CREATE_ATTENSI,
  ROUTE_PRODUCT_CREATE_SCORM,
  ROUTE_PRODUCT_CREATE_SELECT_TYPE,
  ROUTE_PRODUCT_EDIT,
  ROUTE_PRODUCT_TAGS,
  ROUTE_PRODUCT_CHANGE_LOG,
} from '@/router/routes/routeNames'

const Products = () => import('@/components/product/ProductsView.vue')
const ProductCreateSelectType = () =>
  import('@/components/product/ProductCreateSelectTypeView.vue')
const ProductCreate = () => import('@/components/product/ProductCreateView.vue')
const _CreateActivity = () =>
  import('@/components/product/activity/CreateActivityView.vue')
const ProductCreateScorm = () =>
  import('@/components/product/ProductCreateScormView.vue')
const ProductCreateApp = () =>
  import('@/components/product/ProductCreateAppView.vue')
const ProductCreateAttensi = () =>
  import(
    '@/components/product/product_components/product_attensi/ProductCreateAttensiView.vue'
  )
const ProductEdit = () => import('@/components/product/ProductEditView.vue')
const ChangeLog = () => import('@/components/product/ChangeLogView.vue')
const ProductTags = () => import('@/components/product/ProductTagsView.vue')

const productRoutes = [
  {
    name: ROUTE_PRODUCTS,
    path: '/products',
    component: Products,
    meta: { resource: 'Product', requiresPortal: true },
  },
  {
    name: ROUTE_PRODUCT_TAGS,
    path: '/products/tags',
    component: ProductTags,
    meta: { resource: 'Product', requiresPortal: true },
  },
  {
    name: ROUTE_PRODUCT_CREATE_ACTIVITY,
    path: '/products/create/activity',
    component: _CreateActivity,
    meta: {
      resource: ['Product'],
      requiresPortal: true,
      showGlobalHeader: false,
    },
  },
  {
    name: ROUTE_PRODUCT_CREATE,
    path: '/products/create/:productType',
    props: true,
    component: ProductCreate,
    meta: { resource: 'Product', requiresPortal: true },
  },
  {
    name: ROUTE_PRODUCT_CREATE_SCORM,
    path: '/products/create/scorm/:productType',
    props: true,
    component: ProductCreateScorm,
    meta: {
      resource: ['Product', 'enable_scorm_support'],
      requiresPortal: true,
    },
  },
  {
    name: ROUTE_PRODUCT_CREATE_APP,
    path: '/products/create/app/:productType',
    props: true,
    component: ProductCreateApp,
    meta: { resource: ['Product'], requiresPortal: true },
  },
  {
    name: ROUTE_PRODUCT_CREATE_ATTENSI,
    path: '/products/attensi',
    props: false,
    component: ProductCreateAttensi,
    meta: { resource: ['Product'], requiresPortal: false },
  },
  {
    name: ROUTE_PRODUCT_CREATE_SELECT_TYPE,
    path: '/products/create',
    component: ProductCreateSelectType,
    props: true,
    meta: { resource: 'Product', requiresPortal: true },
  },
  {
    name: ROUTE_PRODUCT_CHANGE_LOG,
    path: '/products/:productId/change-log',
    component: ChangeLog,
    props: true,
    meta: {
      resource: 'Product',
      requiresPortal: true,
      showGlobalHeader: false,
    },
  },
  {
    name: ROUTE_PRODUCT_EDIT,
    path: '/products/:productId',
    component: ProductEdit,
    props: true,
    meta: {
      resource: 'Product',
      requiresPortal: true,
      showGlobalHeader: false,
    },
  },
]

export default productRoutes
